import * as React from 'react'

type TableContextType = {
  endCursor: string | null
  createEndCursor: (cursor: string) => void
  hasMore: boolean
  createHasMore: (hasMore: boolean) => void
  isNextPageLoading: boolean
  createIsNextPageLoaded: (loaded: boolean) => void
  toggleSelection: boolean
  createToggleSelection: (toggle: boolean) => void
  data: any
  items: any
  createItems: (items: any) => void
  clearAll: () => void
}

export const TableContext = React.createContext<TableContextType>({
  endCursor: null,
  createEndCursor: () => null,
  hasMore: false,
  createHasMore: () => null,
  isNextPageLoading: false,
  createIsNextPageLoaded: () => null,
  toggleSelection: false,
  createToggleSelection: () => null,
  data: [],
  items: [],
  createItems: () => null,
  clearAll: () => null
})

export const useTableContext = () => React.useContext(TableContext)

const TableProvider: React.FC<{}> = ({ children }) => {
  const [endCursor, setEndCursor] = React.useState<string | null>(null)
  const [items, setItems] = React.useState<any>([])
  const [hasMore, setHasMore] = React.useState<boolean>(true)
  const [isNextPageLoading, setIsNextPageLoading] = React.useState<boolean>(false)
  const [toggleSelection, setToggleSelection] = React.useState<any>(false)
  const data = React.useMemo(() => items, [items])

  function createEndCursor(cursor: string | null) {
    setEndCursor(cursor)
  }
  function createHasMore(more: boolean) {
    setHasMore(more)
  }
  function createIsNextPageLoaded(next: boolean) {
    setIsNextPageLoading(next)
  }
  function createToggleSelection(toggle: boolean) {
    setToggleSelection(toggle)
  }
  function createItems(items: any) {
    setItems(items)
  }

  function clearAll() {
    setItems([])
    setHasMore(true)
    setEndCursor(null)
  }
  return (
    <TableContext.Provider
      value={{
        endCursor,
        hasMore,
        isNextPageLoading,
        toggleSelection,
        data,
        items,
        createEndCursor,
        createHasMore,
        createIsNextPageLoaded,
        createToggleSelection,
        createItems,
        clearAll
      }}
    >
      {children}
    </TableContext.Provider>
  )
}

export default TableProvider
